import { FolderOpen, ChevronRight } from "lucide-react";

export default function DestinationInfo({ destination, folderName, onClick }) {
  const destLabel = destination === "gdrive" ? "Google Drive" : "Dropbox";
  const displayFolder = folderName || "Vimeo Backups";

  return (
    <button
      data-testid="destination-info"
      onClick={onClick}
      className="ug-card p-4 flex items-center gap-4 mb-6 w-full text-left group hover:!border-[rgba(198,169,111,0.3)] transition-colors"
    >
      <div className="w-9 h-9 rounded-lg bg-[#21252b] flex items-center justify-center flex-shrink-0">
        <FolderOpen className="h-4 w-4 text-[#c6a96f]" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <p className="text-xs text-[#e4e4e7]">
            Saving to <span className="font-mono text-[#c6a96f]">{destLabel} / {displayFolder}</span>
          </p>
        </div>
        <p className="text-[10px] text-[#52525b] mt-0.5">// click to change destination folder</p>
      </div>
      <ChevronRight className="h-4 w-4 text-[#3f3f46] group-hover:text-[#c6a96f] transition-colors flex-shrink-0" />
    </button>
  );
}
